/**
 * @object helpers
 * @description Object defining our helpers
 */
function equal(exp1, exp2) {
  return exp1 === exp2;
}
function or(exp1, exp2) {
  return exp1 || exp2;
}
function add(exp1) {
  var exp2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  return exp1 + exp2;
}
export { add, equal, or };